



































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'

import XDialog from '@finance/ssvue/src/components/x-dialog/index.vue'

import useragent from '@finance/useragent'

import { APP, RUN_APP } from '@common/loan-act/env'
import { windowOpen, urlParams } from '@common/loan-act/util'
import {
  LOAN_INDEX_URL as loanIndexUrl,
  RUIDAI_URL,
  FUDAI_URL as fudaiUrl,
  SUISHOU_URL as suishouUrl,
  SUIXIN_URL as suixinUrl
} from '@common/loan-act/url'

import IconTitle from '$components/icon-title/index'
import getTransferCode, { ETransferCode, SELECT_INVERSE } from './get-transfer-code'

const ruidaiUrl = urlParams(
  { nav: RUN_APP === APP.kn ? 'kaniufanxiquan' : 'suishoufanxiquan' },
  RUIDAI_URL
)

interface ISelectConfigItem {
  code: ETransferCode;
  img: any;
  p1: string;
  p2: string;
}

@Component({
  components: {
    XDialog,
    IconTitle
  },
  computed: mapState({
    isLogin: (state: any) => { return state.common.loginState },
  }),
})
export default class LoanTransfer extends Vue {
  ETransferCode = ETransferCode

  transferKey: ETransferCode | '' = ''

  codeHandler = {
    [ETransferCode.SELECT]: this.showPanel,
    [ETransferCode.MARKET]: this.toMarket,
    [ETransferCode.FUDAI]: () => windowOpen(fudaiUrl),
    [ETransferCode.RUIDAI]: () => windowOpen(ruidaiUrl),
    [ETransferCode.SUIXIN]: () => windowOpen(suixinUrl),
    [ETransferCode.SUISHOU]: () => windowOpen(suishouUrl),
    [ETransferCode.SELECT_FUDAI]: this.showPanel,
    [ETransferCode.SELECT_RUIDAI]: this.showPanel,
  }

  selectConfig: ISelectConfigItem[] = [
    {
      code: ETransferCode.RUIDAI,
      img: require('./icon/psp-1.png'),
      p1: '信用卡激活<span class="flag">高通过率</span>',
      p2: '持有信用卡即可快速申请'
    },
    {
      code: ETransferCode.FUDAI,
      img: require('./icon/psp-2.png'),
      p1: '其他方式激活<span class="flag">高额度</span>',
      p2: '凭身份证最高拿20万元'
    },
  ]

  panel = false

  get isIPhoneFullScreen() {
    return useragent.isIPhoneFullScreen
  }

  get code() {
    return this.transferKey.replace(SELECT_INVERSE, '')
  }

  @Watch('isLogin')
  onIsLoginChanged(st: boolean) {
    if (st && !this.transferKey) {
      this.getCode(false)
    }
  }

  handleClick(product: ISelectConfigItem) {
    this.panel = false

    this.codeHandler[product.code]()
  }

  /** 用来兼容 null的异常 */
  toastError() {
    console.log('this.code', this.code)
    this.$ssvue.toast.show('网络异常，请稍后重试~')
  }

  toMarket() {
    windowOpen(loanIndexUrl)
  }

  showPanel() {
    this.panel = true
  }

  async getCode(toast = true) {
    try {
      this.transferKey = await getTransferCode()
    } catch (error) {
      toast && this.$ssvue.toast.show('网络异常，请稍后重试~')
    }
  }

  async exec() {
    await this.getCode()
    if (this.transferKey) {
      const handler = this.codeHandler[this.transferKey]
      handler()
    } else {
      this.toastError()
    }
  }
}
